import React from 'react'

const Button = ({children, className}) => {
    return (
        <span className={ className + ' bg-[var(--primary)] text-[#FFFFFF] font-[500] text-[18px] py-[16px] px-[24px] rounded-[8px] cursor-pointer'}>
            {children}
        </span>
    )
}

export default Button;